import React from "react";
import "../../styles/HowItWorksSection.css";
import { FaUser, FaDollarSign, FaRocket, FaPenFancy, FaLightbulb } from "react-icons/fa";

const HowItWorksSection = () => {
    const steps = [
        {
            icon: FaUser,
            title: "Book a Free Consultation",
            description: "We’ll explore your business, goals, and where automation can save you time and money.",
        },
        {
            icon: FaLightbulb,
            title: "Get a Custom Automation Plan",
            description: "We map out smart workflows using the tools you already use — no learning curve.",
        },
        {
            icon: FaPenFancy,
            title: "We Build Everything for You",
            description: "Our team handles setup, integrations, testing, and delivery — all done-for-you.",
        },
        {
            icon: FaRocket,
            title: "Launch & Scale",
            description: "You go live with your automations and we monitor, adjust, and optimize as you grow.",
        },
        {
            icon: FaDollarSign,
            title: "Save Hours & Grow Revenue",
            description: "Your AI systems run 24/7 in the background — so you can focus on what matters most.",
        },
    ];

    return (
        <div className="how-it-works-section" id="how-it-works">
            <h2 className="section-title">How It Works</h2>
            <p className="section-description">
                From consultation to automation — here’s how we build your custom AI systems step-by-step.
            </p>
            <div className="steps-container">
                {steps.map((step, index) => (
                    <div className="step-wrapper" key={index}>
                        <div className="step-item" data-aos="fade-up" data-aos-delay={`${index * 200}`}>
                            <div className="step-icon">
                                <step.icon className="icon" />
                            </div>
                            <div className="step-content">
                                <h3 className="step-title">{step.title}</h3>
                                <p className="step-description">{step.description}</p>
                            </div>
                        </div>
                        {index < steps.length - 1 && (
                            <div className="step-arrow" data-aos="fade-up" data-aos-delay={`${index * 200 + 100}`}>
                                <span>↓</span> {/* Arrow connecting steps */}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HowItWorksSection;